export const UNIT_TYPES = ["WEIGHT", "VOLUME", "COUNT", "LENGTH", "GENERAL"];

export const UNIT_TYPE_OPTIONS = [
  { label: "Weight", value: "WEIGHT" },
  { label: "Volume", value: "VOLUME" },
  { label: "Count", value: "COUNT" },
  { label: "Length", value: "LENGTH" },
  { label: "General", value: "GENERAL" },
] as const;
